import React, {useState, useEffect, useCallback} from 'react';
import Select from 'react-select';
import {toast} from "react-toastify";
import ApiRoute, {isPrimaryShop} from "../../helper/api";

const ProductSelect2 = ({
    onChange,
    value = null,
    placeholder = 'انتخاب محصول',
    isMulti = false,
    isClearable = true,
    isSearchable = true,
    allowOutStock = false
}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(value);

    const fetchProducts = useCallback(async (searchValue = '') => {
        try {
            setIsLoading(true);
            const response = await ApiRoute.product.index.fn({ title: searchValue});
            const formattedOptions = response.results.data.map(item => ({
                value: item._id,
                label: item.title,
                ...item
            }));
            setOptions(formattedOptions);
        } catch (error) {
            toast.error("خطا در دریافت اطلاعات محصولات");
            console.error(error);
            setOptions([]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const fetchProductById = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const response = await ApiRoute.product.getByIds.fn([id]);
            if (response.results && response.results.length > 0) {
                const product = response.results[0];
                const formattedOption = {
                    value: product._id,
                    label: product.title,
                    ...product
                };
                setSelectedValue(formattedOption);
                setOptions(prev => [...prev, formattedOption]);
            }
        } catch (error) {
            toast.error("خطا در دریافت اطلاعات محصول");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    useEffect(() => {
        if (value) {
            if (typeof value === 'string') {
                fetchProductById(value);
            } else if (value.value) {
                setSelectedValue(value);
            }
        } else {
            setSelectedValue(null);
        }
    }, [value, fetchProductById]);

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        if (newValue.length >= 2) {
            fetchProducts(newValue);
        }
    };

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption);
        if (onChange) {
            onChange(selectedOption);
        }
    };

    const formatOptionLabel = (item) => {
        const stockStatus = item?.stocks?.live < 1 ? (
            <span className="text-red-500 mr-1">(ناموجود)</span>
        ) : null;

        const privateStatus = item.status === "private" ? (
            <span className="text-[#c750bf] mr-1">(خصوصی)</span>
        ) : null;

/*         if (isPrimaryShop()) {
            return (
                <div className="flex flex-wrap gap-2 justify-between text-13">
                    <div>
                        {item.title}
                        {stockStatus}
                        {privateStatus}
                        {item?.sku && item.sku.toLowerCase().includes("khno-") ? (<span className={`text-blue-4 mr-1`}>(خانگینو)</span>) : ''}
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="text-green-500">{item?.sku}</div>
                        <div className="text-green-500">م ({item?.stocks?.web_site})</div>
                        <div className="text-blue-500"> م.پ ({item?.stocks?.presell})</div>
                    </div>
                </div>
            );
        } */

        return (
            <div className="flex flex-wrap gap-2 justify-between text-13">
                <div>
                    {item.title}
                    {stockStatus}
                    {privateStatus}
                    {item?.sku && item.sku.toLowerCase().includes("khno-") ? (<span className={`text-blue-4 mr-1`}>(خانگینو)</span>) : ''}
                </div>
                <div className="flex items-center gap-2">
                    <div className="text-green-500">{item?.sku}</div>
                    <div className="text-green-500">م ({item?.stocks?.web_site})</div>
                </div>
            </div>
        );
    };

    const filterOption = (option) => {
        if (allowOutStock) return true;
        return option.data?.stocks?.live > 0;
    };

    const customStyles = {
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999
        }),
        control: (base) => ({
            ...base,
            minHeight: '30px',
            fontSize: '13px'
        }),
        valueContainer: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        option: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        multiValue: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        input: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        menu: (base) => ({
            ...base,
            fontSize: '13px'
        })
    };

    return (
        <Select
            className="w-full"
            classNamePrefix="select"
            isLoading={isLoading}
            isClearable={isClearable}
            isSearchable={isSearchable}
            styles={customStyles}
            isMulti={isMulti}
            options={options}
            value={selectedValue}
            onChange={handleChange}
            onInputChange={handleInputChange}
            inputValue={inputValue}
            placeholder={placeholder}
            formatOptionLabel={formatOptionLabel}
            filterOption={filterOption}
            noOptionsMessage={() => "محصولی یافت نشد"}
            loadingMessage={() => "در حال جستجو..."}
            menuPortalTarget={document.body}
            menuPosition="fixed"
        />
    );
};

export default ProductSelect2;